/**
 * One row in the Incoming Invoices table.
 *
 * `invoiceNumber` is stored without the leading `#` — the table view
 * adds the symbol at render time so the underlying value stays clean
 * for filtering, sorting, and copy-paste. `date` is an ISO-8601 string
 * (consistent with `SalesProvider.dateRange.start`/`end` and other
 * widgets) so dayjs can parse it without per-call format hints.
 */
export type PendingInvoice = {
    currency: string;
    date: string;
    /** Ancillary charges on the invoice — freight, customs, … */
    expensesTotal: number;
    expensesTotalTetri: number;
    id: string;
    invoiceNumber: string;
    /** The line items as issued. */
    linesTotal: number;
    linesTotalTetri: number;
    productCount: number;
    supplier: string;
    /** `linesTotal + expensesTotal`. */
    totalAmount: number;
    totalAmountTetri: number;
};

/**
 * Format an `invoiceNumber` for display. Centralised so every place that
 * shows the number (table cell, future modal heading, future toasts)
 * uses the same `#WB-IN-…` shape.
 */
export const formatInvoiceNumber = (invoiceNumber: string): string =>
    `#${invoiceNumber}`;

/** Row-level actions surfaced in the table's pinned actions dropdown. */
export type PendingInvoiceRowAction = 'import';

export const PENDING_INVOICE_ROW_ACTIONS: {
    id: PendingInvoiceRowAction;
    icon: string;
    labelKey: string;
    variant?: 'danger';
}[] = [
    {
        id: 'import',
        icon: 'solar:download-square-bold-duotone',
        labelKey: 'purchases.widgets.pendingInvoices.import',
    },
];
